export const tabTitleTypes = {
  CHANGE_TAB: "CHANGE_TAB",
  CLEAR_TAB: "CLEAR_TAB",
};
